<!-- <mat-form-field> -->
<!-- <input type="text" matInput [formControl]="control" [name]="control.name" [placeholder]="placeholder" [errorStateMatcher]="matcher" /> -->
<mat-slide-toggle [disabled]="disabled || readOnly" [formControl]="control" [name]="control.name">
	{{ placeholder }}
	<!-- https://github.com/angular/material2/issues/7739 : Vive la bidouille ! -->
	<ng-template ngFor let-key [ngForOf]="control.validationKeys" ngProjectAs="mat-error">
		<mat-error *ngIf="control.hasError(key)">
			{{ control.getErrorMessage(key) }}
		</mat-error>
	</ng-template>
</mat-slide-toggle>
